import React from "react";
import "./MM.css";

import prod1 from "../../../Gallery/ServicesImages/MM/img1.png";
import prod2 from "../../../Gallery/ServicesImages/MM/img2.png";
import inj1 from "../../../Gallery/ServicesImages/MM/img3.png";
import inj2 from "../../../Gallery/ServicesImages/MM/img4.png";
import inj3 from "../../../Gallery/ServicesImages/MM/img5.png";
import inj4 from "../../../Gallery/ServicesImages/MM/img6.png";

function MM() {
  return (
    <div className="mm_page">

      {/* ================= HERO ================= */}
      <section className="mm_hero">
        <div className="mm_hero_inner">
          <h1>
            Precision Mold Manufacturing <br />
            From Concept to Production
          </h1>
          <p>
            High-performance molds engineered for durability,
            accuracy, and long production life.
          </p>
        </div>
      </section>

      {/* ================= ABOUT ================= */}
      <section className="mm_about">
        <h2>Advanced Mold Engineering</h2>
        <p>
          Modern mold manufacturing combines precision machining,
          CAD/CAM integration, and engineering validation to produce
          tooling that performs consistently under demanding production cycles.
        </p>
        <p>
          From prototype tooling to multi-cavity production molds,
          designs are optimized for strength, efficiency, reduced cycle time,
          and long-term reliability across industrial applications.
        </p>
      </section>

      {/* ================= CAPABILITIES ================= */}
      <section className="mm_capabilities">
        <h2>Core Capabilities</h2>

        <div className="mm_cap_grid">
          <div className="mm_cap_card">
            <h3>Design & Development</h3>
            <ul>
              <li>3D CAD / CAM integration</li>
              <li>Mold flow simulation</li>
              <li>Value engineering solutions</li>
            </ul>
          </div>

          <div className="mm_cap_card">
            <h3>Manufacturing</h3>
            <ul>
              <li>Hot & cold runner systems</li>
              <li>Precision CNC machining</li>
              <li>High tolerance tooling</li>
            </ul>
          </div>

          <div className="mm_cap_card">
            <h3>Quality Control</h3>
            <ul>
              <li>Dimensional verification</li>
              <li>Surface finish inspection</li>
              <li>Performance validation testing</li>
            </ul>
          </div>
        </div>
      </section>

      {/* ================= INFRASTRUCTURE ================= */}
      <section className="mm_infra">
        <h2>Manufacturing Infrastructure</h2>
        <div className="mm_infra_grid">
          <div>✔ CNC EDM & Surface Grinding</div>
          <div>✔ Vertical & Horizontal Milling</div>
          <div>✔ CAD / CAM Workstations</div>
          <div>✔ Mold Flow Analysis</div>
          <div>✔ Precision Measurement Tools</div>
          <div>✔ Tool Room Facilities</div>
        </div>
      </section>

      {/* ================= PRODUCTION MOLDS ================= */}
      <section className="mm_gallery">
        <h2>Production Molds</h2>
        <div className="mm_gallery_two">
          <img src={prod1} alt="Production Mold 1" />
          <img src={prod2} alt="Production Mold 2" />
        </div>

        <h2 className="mt">Injection Molded Parts</h2>
        <div className="mm_gallery_four">
          <img src={inj1} alt="Injection Part 1" />
          <img src={inj2} alt="Injection Part 2" />
          <img src={inj3} alt="Injection Part 3" />
          <img src={inj4} alt="Injection Part 4" />
        </div>
      </section>

    </div>
  );
}

export default MM;
